<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Products from '../../productStorages/views/Products.vue'
	//import EditProduct from './EditProduct.vue'
	//import Buttons from './Buttons.vue'
	import productStorages from '../../productStorages/layout/productStorages.vue'
	import Profit from './Profit'
	import Navbar from './Navbar'

	export default {
		props: ['user', 'isAuth'],
		components: {
			//'buttons': Buttons,
			'products': Products,
			//'edit-product': EditProduct,
			'product-storages': productStorages,
			'profit': Profit,
			'navbar': Navbar,
		},
		data () {
			return {
				modal: {
					selector: 'product-create',
				},
				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin',
				},
				item: null,
				loading: false,
			}
		},
		watch: {
			'item.hide_totals'() {
				var div = $('#hide-totals')
				div.addClass('disabled')
				this.$http.put('admin/management/budgets/' + this.item.id, {
					hide_totals: this.item.hide_totals
				})
				.then(response => {
					div.removeClass('disabled')
				}).catch(function(response) {
					console.log(response)
					div.removeClass('disabled')
				})
			},
			$route() {
				this.init()
			},
			'item.discount'() {
				this.item.discount = this.$options.filters.checkDecimals(this.item.discount)
				this.calculateSave()
				this.calculateAmount()
				this.calculateTaxes()
				this.calculateTotal()

				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData () {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/management/budgets/' + id + '/edit')
						.then(response => {
							this.item = response.body
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
						}).catch(response => {
							console.log(response)
							$('#table-products tbody tr').removeClass('disabled')
							$('#table-products tbody tr td input').attr('disabled', false)
							if(response.status == 423) {
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							} else {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
						})
				}
			},
			editProduct(product) {
				this.$refs.productStorages.editProduct(product)
			},
			update() {
				this.loading = true
				var that = this
				var loading = Ladda.create(this.$refs.btnUpdate)
				var btnupdateDiscount = Ladda.create(this.$refs.btnupdateDiscount)
				loading.start()
				btnupdateDiscount.start()
				this.$http.put('admin/management/budgets/' + this.item.id, this.item)
				.then(response => {
					this.loading = false
					loading.stop()
					btnupdateDiscount.stop()
					$('#modal-edit-budget').modal('hide')
					this.reload()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					loading.stop()
					btnupdateDiscount.stop()
					$('#modal-edit-budget').modal('hide')
					this.reload()
				})
			},
			//--
			recalculate() {
				this.$refs.profit.calculateProfit()
				this.calculateSave()
				this.calculateAmount()
				this.calculateTaxes()
				this.calculateTotal()
			},
			calculateSave() {
				var amount = 0
				var total_save = 0

				if(this.item.products) {
					if(this.item.products.length) {
						this.item.products.forEach(function(product) {
							if(product.total_price_quantity) {
								var total_price_quantity = parseFloat(product.total_price_quantity)
							} else {
								var total_price_quantity = 0
							}

							amount = amount + total_price_quantity

							if(product.save) {
								var save = parseFloat(product.save)
							} else {
								var save = 0
							}

							if(product.total_measurement_unit_quantity) {
								var total_measurement_unit_quantity = product.total_measurement_unit_quantity
							} else {
								var total_measurement_unit_quantity = 0
							}
							total_save = total_save + (save * total_measurement_unit_quantity)
						})
					}
				}

				if(this.item.discount) {
					var discount = parseFloat(this.item.discount)
				} else {
					var discount = 0
				}

				if(this.item.discount > 100) {
					var total = -Math.abs(amount * discount / 100)
				} else {
					var total = amount * discount / 100
				}

				if(total < 0) {
					total = Math.abs(total)
				}

				this.item.save = parseFloat(total_save + total).toFixed(2)
			},
			calculateAmount() {
				if(this.item.base_amount) {
					var base_amount = parseFloat(this.item.base_amount)
				} else {
					var base_amount = 0
				}

				if(this.item.save) {
					var save = parseFloat(this.item.save)
				} else {
					var save = 0
				}

				if(save < 0) {
					save = Math.abs(save)
				}

				var amount = base_amount - save

				this.item.amount = parseFloat(amount).toFixed(2)
			},
			calculateTaxes() {
				if(this.item.tax) {
					if(this.item.amount) {
						var amount = parseFloat(this.item.amount)
					} else {
						var amount = 0
					}

					var taxes = amount * this.item.tax.value / 100
					this.item.taxes = parseFloat(taxes).toFixed(2)
				} else {
					this.item.taxes = 0
				}
			},
			calculateTotal() {
				if(this.item.taxes) {
					var taxes = parseFloat(this.item.taxes)
				} else {
					var taxes = 0
				}

				if(this.item.amount) {
					var amount = parseFloat(this.item.amount)
				} else {
					var amount = 0
				}

				this.item.total = parseFloat(amount + taxes).toFixed(2)
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/budgets/views/Edit.vue